import { Content } from './src/Content.js';
import { Dialog as Dialog$1 } from './src/Dialog.js';
import { Footer } from './src/Footer.js';
import { Header } from './src/Header.js';

const Dialog = Dialog$1;
Dialog.Header = Header;
Dialog.Footer = Footer;
Dialog.Content = Content;

export { Dialog };
//# sourceMappingURL=index.js.map
